import React from "react";
import { DatePicker } from "@material-ui/pickers";
import clsx from "clsx";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from '@material-ui/core/InputAdornment';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
const DateRangePicker = ({
  onChange,
  autoOk,
  labelFunc,
  emptyLabel,
  label,
  required,
  disabled,
  ...props
}) => {
  const classes = useStyles();
  const [begin, setBegin] = React.useState(undefined);
  const [end, setEnd] = React.useState(undefined);
  const [hover, setHover] = React.useState(undefined);
  const picker = React.useRef();

  const min = Math.min(begin, end || hover);
  const max = Math.max(begin, end || hover);

  const formatdaysSelectLabel = (date, invalid) => {

    if (begin > end) {
      let temp = begin;
      setBegin(end);
      setEnd(temp);
    }
    return labelFunc
      ? labelFunc([begin, end].sort(), invalid)
      : date && begin && end
        ? `${format(begin, "dd-MM-yyyy")} To ${format(end, "dd-MM-yyyy")}`
        : emptyLabel || "";
  };


  function renderDay(
    day,
    selectedDate,
    dayInCurrentMonth,
    dayComponent,
    props
  ) {
    return React.cloneElement(dayComponent, {
      onClick: (e) => {
        e.stopPropagation();
        if (!begin) setBegin(day);
        else if (!end) {
          setEnd(day);
          if (autoOk) {
            onChange([begin, day].sort());
            picker.current.close();
          }
        } else {
          setBegin(day);
          setEnd(undefined);
        }
      },
      onMouseEnter: (e) => day,
      className: clsx({
        [classes.current]: isSameDay(begin, day),
        [classes.highlight]: day >= min && day <= max,
        [classes.firstHighlight]: isSameDay(min, day) && (min !== max),
        [classes.endHighlight]: isSameDay(max, day) && (min !== max),
        [classes.sameDay]: isSameDay(end, day) && (min === max),
      }),
    });
  }


  return (
    <DatePicker
      {...props}
      label={label}
      value={begin}
      clearable
      required={required}
      disabled={disabled}
      fullWidth
      onChange={() => {
        onChange(formatdaysSelectLabel(begin));
      }}
      onClear={() => {
        setBegin(undefined);
        setEnd(undefined);
        setHover(undefined);
        onChange([]);
      }}
      renderDay={renderDay}
      labelFunc={formatdaysSelectLabel}
      inputVariant="outlined"
      size="small"
      InputProps={{
        endAdornment: <InputAdornment position="end"><DateRangeOutlinedIcon style={{ color: "grey" }}/></InputAdornment>,
      }}
    />

  );
}

const useStyles = makeStyles((theme) => ({
  dayWrapper: {
    position: "relative",
  },
  day: {
    width: 36,
    height: 36,
    fontSize: theme.typography.caption.fontSize,
    margin: "0 2px",
    color: "inherit",
  },
  nonCurrentMonthDay: {
    color: theme.palette.text.disabled,
  },
  highlightNonCurrentMonthDay: {
    color: "#676767",
  },
  current: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: "50% 0 0 50%"
  },
  highlight: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: "0",
    margin: 0,
    width: "40px",
  },
  firstHighlight: {
    extend: "highlight",
    borderRadius: "50% 0 0 50%"
  },
  endHighlight: {
    extend: "highlight",
    borderRadius: "0 50% 50% 0"
  },
  sameDay: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: "50% 50% 50% 50%"
  }
}));

export default DateRangePicker;
